<div class="pt-3" *ngIf="notFound">
  <h2>Event not found</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6" *ngIf="!notFound && (serverError === null)">
  <div class="row">
    <div class="col">
      <p class="mt-2" style="width:100%;text-align:center">
        <span *ngIf="eventType === null">LOADING EVENT...</span>
        <span *ngIf="eventType !== null">EDIT EVENT: {{ eventType.name }}</span>
      </p>
    </div>
  </div>

  <div id="day-to-add-datepicker-container"></div>

  <div class="mb-3 border-rounded-10">

    <app-event-setup-nav [loadingEventType]="loadingEventType" [eventType]="eventType"></app-event-setup-nav>

    <div class="m-4" *ngIf="isLoading()">
      <h3 class="text-muted">Loading...</h3>
    </div>

    <div class="m-4" *ngIf="!notFound && (serverError === null) && !isLoading()">

      <div class="form-group">
        <label for="nameInput">Schedule Exception Name</label>
        <input type="text" class="form-control"
               name="name"
               id="nameInput"
               [(ngModel)]="scheduleException.name">
        <small class="form-text text-muted">This name is optional, and is only used to organize this list. It is not displayed to customers.</small>
        <div class="form-text text-danger">
          {{ errors.name }}
        </div>
      </div>

      <div class="form-group" *ngIf="eventType?.schedule_type === ScheduleType.rolling">
        <label for="roster">Roster</label>
        <select class="custom-select"
                id="roster" name="roster"
                [(ngModel)]="scheduleException.roster_id"
                (ngModelChange)="handleRosterChange()"
                [disabled]="loadingScheduleException || loadingRosters || !isNewScheduleException"
                [class.disabled]="loadingScheduleException || loadingRosters || !isNewScheduleException">
          <option *ngIf="loadingScheduleException || loadingRosters">Loading...</option>
          <ng-container *ngIf="!(loadingScheduleException || loadingRosters)">
            <!--
              "All Rosters" is deliberately the default selection, not a
              disabled placeholder: blacking a day out across the whole event
              type is the common case this option was added for (PRO-1432).
            -->
            <option [ngValue]="null">All Rosters</option>
            <option *ngFor="let roster of rosters"
                    [ngValue]="roster.id">
              {{ roster.name }}
            </option>
          </ng-container>
        </select>
        <small class="form-text text-muted">
          <ng-container *ngIf="isAllRostersException()">This schedule exception overrides the schedules of every roster of this event type at the selected location. Choose a roster instead to override only that roster’s schedules, leaving every other roster’s usual events in place.</ng-container>
          <ng-container *ngIf="!isAllRostersException()">This schedule exception overrides the selected roster’s schedules only — every other roster keeps its usual events on these days. Choose “All Rosters” to apply it to every roster of this event type at the selected location instead.</ng-container>
        </small>
        <div class="form-text text-danger">{{ errors.roster_id }}</div>
      </div>

      <div class="form-group">
        <label for="selectLocation">Location</label>
        <select class="custom-select"
                id="selectLocation" name="selectLocation"
                [(ngModel)]="scheduleException.location_id"
                [disabled]="loadingScheduleException || !isNewScheduleException"
                [class.disabled]="loadingScheduleException || !isNewScheduleException">
          <option *ngFor="let location of locationService.getLocations()"
                  [ngValue]="location.id">
            {{ location.name }}
            <ng-container *ngIf="(eventType?.schedule_type === ScheduleType.rolling) && (selectedRosterLocationId === location.id)">
              (Roster location)
            </ng-container>
          </option>
        </select>
        <small class="form-text text-muted">
          This is the location whose schedules this schedule exception overrides.<ng-container *ngIf="eventType?.schedule_type === ScheduleType.rolling"> It starts out as the selected roster’s own location, but a roster’s schedules may run at another location, so it can be changed.</ng-container>
        </small>
        <div class="form-text text-danger">{{ errors.location_id }}</div>
      </div>

      <!--
        The choice this whole form turns on. A schedule exception always clears
        the usual events from its days; whether it puts anything back is
        decided by whether it carries time slots, which staff read as "when was
        the cancelled event" and fill in anyway (PRO-1508). Nothing new is
        stored - the mode IS the time slot list - so this control both gates the
        section below and empties that list when it is saved as a cancellation.
      -->
      <div class="form-group">
        <fieldset>
          <label>What should happen on these days?</label>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="exceptionMode"
                   id="exceptionModeCancel"
                   [value]="ExceptionMode.cancelEvents"
                   [(ngModel)]="exceptionMode"
                   (ngModelChange)="handleExceptionModeChange()">
            <label class="form-check-label" for="exceptionModeCancel">
              Cancel the usual events
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="exceptionMode"
                   id="exceptionModeReplace"
                   [value]="ExceptionMode.replaceEvents"
                   [disabled]="isAllRostersException()"
                   [(ngModel)]="exceptionMode"
                   (ngModelChange)="handleExceptionModeChange()">
            <label class="form-check-label" for="exceptionModeReplace"
                   [class.text-muted]="isAllRostersException()">
              Run different events instead
            </label>
          </div>
        </fieldset>
        <small class="form-text text-muted">
          Either way the usual events are removed from every day listed below. “Run different events instead” also creates an event at each time slot you add, on each of those days.
        </small>
        <div class="alert alert-info mt-2" role="alert"
             *ngIf="isAllRostersException()">
          An “All Rosters” schedule exception can only remove the usual events from its days. It cannot run different events in their place. To do that, add a separate schedule exception for each roster instead.
        </div>
      </div>

      <div class="row mb-5">

        <div class="col-md-6">
          <p><b>Exception Days</b></p>

          <div *ngFor="let date of scheduleException.dates; let idx = index;">

            <div class="form-group">
              <div class="row">
                <div class="col-8">
                  <input class="form-control disabled"
                         disabled
                         value="{{ dateStringFromISO8601(scheduleException.dates[idx]) }}">
                </div>
                <div class="col-4">
                  <button class="btn btn-danger"
                          (click)="scheduleException.dates.splice(idx, 1)">
                    Remove
                  </button>
                </div>
              </div>
            </div>

          </div>

          <div *ngIf="scheduleException.dates.length === 0">
            <p class="text-muted">
              No Days
            </p>
          </div>

          <div class="form-group">
            <div class="row">
              <div class="col-8">
                  <app-date-picker [id]="'dayToAdd'"
                                   [(content)]="dayToAdd"
                                   containerIdOverride="day-to-add-datepicker-container"></app-date-picker>
              </div>
              <div class="col-4">
                <button class="btn btn-success"
                        [disabled]="dayToAdd === ''"
                        [class.disabled]="dayToAdd === ''"
                        (click)="scheduleException.dates.push(dayToAdd)">
                  Add Day
                </button>
              </div>
            </div>
          </div>

          <div class="form-text text-danger">
            {{ errors.dates }}
          </div>
        </div>

        <div class="col-md-6" *ngIf="isReplacementMode()">
          <p><b>Reservation Time Slots</b></p>

          <p class="text-muted">
            An event runs at each of these times on every day listed, in place of the usual ones.
          </p>

          <div *ngFor="let timeSlot of scheduleException.time_slots; let idx = index;">

            <div class="form-group">
              <label>Start Time</label>
              <div class="row">
                <div class="col-8">
                  <input type="time"
                         class="form-control disabled" disabled
                         [(ngModel)]="scheduleException.time_slots[idx]">
                </div>
                <div class="col-4">
                  <button class="btn btn-danger"
                          (click)="scheduleException.time_slots.splice(idx, 1)">
                    Remove
                  </button>
                </div>
              </div>
            </div>

          </div>

          <div *ngIf="scheduleException.time_slots.length === 0">
            <p class="text-muted">
              No Time Slots
            </p>
          </div>

          <div class="form-group">
            <label>Start Time</label>
            <div class="row">
              <div class="col-8">
                <input type="time" step="60"
                       class="form-control" name="startTime"
                       [(ngModel)]="timeSlotToAdd">
              </div>
              <div class="col-4">
                <!--
                  Disabled while blank, as "Add Day" above already is: save()
                  strips a blank slot again, so adding one would leave the list
                  looking filled and then quietly drop it (PRO-1433).
                -->
                <button class="btn btn-success"
                        [disabled]="timeSlotToAdd === ''"
                        [class.disabled]="timeSlotToAdd === ''"
                        (click)="scheduleException.time_slots.push(timeSlotToAdd)">
                  Add Time Slot
                </button>
              </div>
            </div>
          </div>

          <div class="form-text text-danger">
            {{ errors.time_slots }}
          </div>
        </div>

      </div>

      <!--
        Everything below shapes the events this schedule exception creates - one
        per time slot, on each of its days. A cancellation creates none, so none
        of it applies and all of it is deferred until the mode above says
        otherwise (PRO-1433, PRO-1508). Only the rendering is gated, so anything
        already entered survives a trip through the other mode.
      -->
      <ng-container *ngIf="isReplacementMode()">

        <div class="form-group">
          <ng-container *ngIf="loadingScheduleException || loadingLocationAreas">
            <label>Area</label>
            <a class="float-right" routerLink="/areas-config" target="_blank">
              Configure Areas
            </a>
            <select class="custom-select" disabled>
              <option>Loading...</option>
            </select>
          </ng-container>
          <ng-container *ngIf="!(loadingScheduleException || loadingLocationAreas)">
            <label for="locationAreaSelect">
              Area
            </label>
            <div class="float-right">
              <a href="#"
                 (click)="$event.preventDefault();loadLocationAreas();">
                Refresh Areas
              </a>
              |
              <a routerLink="/areas-config" target="_blank">
                Configure Areas
              </a>
            </div>
            <select class="custom-select" id="locationAreaSelect" name="gym_area_id"
                    [(ngModel)]="scheduleException.location_area_id">
              <option [ngValue]="null">No Area</option>
              <option *ngFor="let locationArea of getLocationAreasForLocation()" [ngValue]="locationArea.id">
                {{ locationArea.name }} (Capacity {{ locationArea.capacity }})
              </option>
            </select>
          </ng-container>
          <small class="form-text text-muted clearfix">
            Setting an area will cap capacity for individual events once the area's capacity has been met. This is optional, and capacity may also be set per time slot.
          </small>
          <div class="form-text text-danger">{{ errors.location_area_id }}</div>
        </div>

        <div class="form-group">
          <label for="rollingDays">
            <ng-container *ngIf="eventType?.schedule_type !== ScheduleType.rolling">
              How far in advance can someone book this event?
            </ng-container>
            <ng-container *ngIf="eventType?.schedule_type === ScheduleType.rolling">
              How far in advance should events be created for this schedule exception?
            </ng-container>
          </label>
          <div class="row">
            <div class="col-6">
              <div class="input-group">
                <input type="number" class="form-control"
                       name="rollingDays"
                       id="rollingDays"
                       min="1" max="90" step="1"
                       [(ngModel)]="scheduleException.rolling_days">
                <div class="input-group-append">
                  <span class="input-group-text">days</span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-text text-danger">
            {{ errors.rolling_days }}
          </div>
        </div>

        <div class="form-group" *ngIf="eventType?.schedule_type !== ScheduleType.rolling">
          <label for="booking_open_time">
            At what time of day does booking open for this event?
          </label>
          <div class="row">
            <div class="col-6">
              <div class="input-group">
                <input type="time" class="form-control"
                       name="booking_open_time"
                       id="booking_open_time"
                       [(ngModel)]="scheduleException.booking_open_time">
              </div>
            </div>
          </div>
          <small class="form-text text-muted">
            Use this setting to determine at what time of day (in the location's local time) this event first becomes available for booking. The default, midnight ("00:00", or "12 AM"), is counted as the <i>start</i> of the day.
          </small>
          <div class="form-text text-danger">
            {{ errors.booking_open_time }}
          </div>
        </div>

        <div class="form-group"
             *ngIf="eventType?.schedule_type !== ScheduleType.rolling">
          <label>Capacity per Time Slot</label>
          <div class="row">
            <div class="col-6">
              <input type="number" class="form-control" name="capacity"
                     min="1" max="1000" step="1"
                     [(ngModel)]="scheduleException.capacity">
            </div>
          </div>
          <div class="form-text text-danger">
            {{ errors.capacity }}
          </div>
        </div>

        <ng-container *ngIf="eventType?.schedule_type !== ScheduleType.rolling">

          <div class="form-group">
            <label>Pricing Matrix</label>
            <div class="row">
              <div class="col-6">
                <select class="custom-select" name="pricing_matrix_id"
                        [(ngModel)]="scheduleException.pricing_matrix_id">
                  <option [ngValue]="null" class="text-muted">None</option>
                  <option *ngFor="let pricingMatrix of pricingMatrices"
                          [ngValue]="pricingMatrix.id">
                    {{ pricingMatrix.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-text text-danger">
              {{ errors.pricing_matrix_id }}
            </div>
          </div>

          <div class="form-group">
            <div class="row">
              <div class="col-sm-8 col-lg-6">
                <label for="tax_rate_id">Tax Rate</label>
                <div class="float-right">
                  <a href="#"
                     (click)="$event.preventDefault();loadTaxRates();">
                    Refresh Tax Rates
                  </a>
                  |
                  <a routerLink="/tax-rates-config" target="_blank">
                    Configure Tax Rates
                  </a>
                </div>
                <select class="custom-select"
                        name="tax_rate_id" id="tax_rate_id"
                        *ngIf="!loadingTaxRates"
                        [(ngModel)]="scheduleException.tax_rate_id">
                  <option [ngValue]="null">
                    Event Type Default ({{ getEventTypeTaxRate() }})
                  </option>
                  <option *ngFor="let taxRate of taxRateList"
                          [ngValue]="taxRate.id">
                    {{ taxRate.name }} - {{ taxRate.rate_percent }}%
                  </option>
                </select>
                <select class="custom-select"
                        *ngIf="loadingTaxRates" disabled>
                  <option>Loading...</option>
                </select>
              </div>
            </div>
          </div>

        </ng-container>

        <ng-container *ngIf="eventType?.schedule_type === ScheduleType.repeating">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <ng-container *ngIf="loadingScheduleException || loadingBenefitMemberships">
                  <label>Benefit Membership (optional)</label>
                  <select class="custom-select" disabled>
                    <option>Loading...</option>
                  </select>
                </ng-container>
                <ng-container *ngIf="!(loadingScheduleException || loadingBenefitMemberships)">
                  <label for="benefit_membership_id">
                    Benefit Membership (optional)
                  </label>
                  <div class="float-right">
                    <a href="#"
                       (click)="$event.preventDefault();loadBenefitMemberships();">
                      Refresh Memberships
                    </a>
                    |
                    <a routerLink="/memberships-and-passes" target="_blank">
                      Configure Memberships
                    </a>
                  </div>
                  <select class="custom-select"
                          id="benefit_membership_id"
                          name="benefit_membership_id"
                          [(ngModel)]="scheduleException.benefit_membership_id">
                    <option [ngValue]="null">No Benefit Membership</option>
                    <option *ngIf="benefitMembershipRetired(scheduleException.benefit_membership_id)"
                            [ngValue]="scheduleException.benefit_membership_id">
                      {{ scheduleException.benefit_membership_name }} (Retired)
                    </option>
                    <option *ngFor="let membership of benefitMembershipList"
                            [ngValue]="membership.id">
                      {{ membership.name }}
                    </option>
                  </select>
                </ng-container>
                <small class="form-text text-muted clearfix">
                  Each participant booked onto a session from this schedule exception receives the benefit membership from the beginning of the session's day through the end of that day, plus the additional days. Participants already booked onto upcoming sessions receive it when the schedule exception is saved; sessions that have already started are not changed.
                  <br>
                  Only active memberships with Purchase Type "Benefit" may be selected.
                </small>
                <div class="form-text text-danger">{{ errors.benefit_membership_id }}</div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="benefit_membership_additional_days">
                  Benefit Additional Days After Event
                </label>
                <div class="input-group">
                  <input type="number" class="form-control"
                         name="benefit_membership_additional_days"
                         id="benefit_membership_additional_days"
                         min="0" max="365" step="1"
                         [disabled]="scheduleException.benefit_membership_id === null"
                         [(ngModel)]="scheduleException.benefit_membership_additional_days">
                  <div class="input-group-append">
                    <span class="input-group-text">days</span>
                  </div>
                </div>
                <small class="form-text text-muted">
                  The number of additional days after the event that the benefit membership should extend. For example, with 13 additional days, a session on 5 October grants the membership through the end of 18 October.
                </small>
                <div class="form-text text-danger">{{ errors.benefit_membership_additional_days }}</div>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="form-group">
          <label>Duration (minutes)</label>
          <div class="row">
            <div class="col-6">
              <input type="number" class="form-control" name="duration_minutes"
                     min="1" max="1440" step="1"
                     [(ngModel)]="scheduleException.duration_minutes">
            </div>
          </div>
          <div class="form-text text-danger">
            {{ errors.duration_minutes }}
          </div>
        </div>

      </ng-container>

      <div class="alert alert-danger" role="alert"
           *ngIf="getDeferredFieldErrors().length > 0">
        <div *ngFor="let deferredFieldError of getDeferredFieldErrors()">
          {{ deferredFieldError }}
        </div>
      </div>

      <div class="alert alert-danger" role="alert"
           *ngIf="errors.non_field_errors">
        {{ errors.non_field_errors }}
      </div>
      <div class="alert alert-danger" role="alert"
           *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <div class="alert alert-info" role="alert"
           *ngIf="loadingSave">
        Saving...
      </div>

      <button class="btn btn-primary float-right"
              [disabled]="isLoading()" [class.disabled]="isLoading()"
              (click)="save()">
        Save Schedule Exception
      </button>

      <a class="btn btn-secondary"
              [routerLink]="'/events/setup/edit/' + eventType?.id + '/schedule-exceptions'">
        Cancel
      </a>

    </div>

  </div>

</div>
